export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <span className="inline-block bg-[#3B1F6E]/8 text-[#3B1F6E] text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-full mb-6">About QRU</span>
      <h1 className="font-serif-display text-4xl sm:text-5xl font-bold text-[#0A0F1D] tracking-tight leading-tight">Considered work, delivered with intent.</h1>
      <div className="mt-8 space-y-5 text-lg text-slate-600 leading-relaxed">
        <p>QRU Online is a small, focused storefront for finished digital books and resources. Everything you see here is customer-ready and delivered instantly after purchase.</p>
        <p>We believe great knowledge deserves great presentation — clean, calm, and easy to return to. No clutter, no noise, just work worth keeping.</p>
        <p>Each title is prepared with care, priced fairly, and yours to download and revisit whenever you like.</p>
      </div>
    </div>
  );
}
